import { render, staticRenderFns } from "./timeSelct1.vue?vue&type=template&id=54c8b350&scoped=true&"
import script from "./timeSelct1.vue?vue&type=script&lang=js&"
export * from "./timeSelct1.vue?vue&type=script&lang=js&"
import style0 from "./timeSelct1.vue?vue&type=style&index=0&id=54c8b350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8b350",
  null
  
)

export default component.exports